/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentExpectedPolicy,
  AgentExpectedPolicy$Outbound,
  AgentExpectedPolicy$outboundSchema,
} from "./agentexpectedpolicy.js";

export type DeleteAgentPolicyGrantForm = {
  /**
   * First-class agent identifier
   */
  agentId: string;
  expectedPolicy?: AgentExpectedPolicy | undefined;
  /**
   * Direct policy grant identifier
   */
  grantId: string;
};

/** @internal */
export type DeleteAgentPolicyGrantForm$Outbound = {
  agent_id: string;
  expected_policy?: AgentExpectedPolicy$Outbound | undefined;
  grant_id: string;
};

/** @internal */
export const DeleteAgentPolicyGrantForm$outboundSchema: z.ZodMiniType<
  DeleteAgentPolicyGrantForm$Outbound,
  DeleteAgentPolicyGrantForm
> = z.pipe(
  z.object({
    agentId: z.string(),
    expectedPolicy: z.optional(AgentExpectedPolicy$outboundSchema),
    grantId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
      expectedPolicy: "expected_policy",
      grantId: "grant_id",
    });
  }),
);

export function deleteAgentPolicyGrantFormToJSON(
  deleteAgentPolicyGrantForm: DeleteAgentPolicyGrantForm,
): string {
  return JSON.stringify(
    DeleteAgentPolicyGrantForm$outboundSchema.parse(deleteAgentPolicyGrantForm),
  );
}
